import React from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

const Splinearea = ({ dataColors, series }) => {
  const spineareaChartColors = getChartColorsArray(dataColors)

  // const series = [
  //   {
  //     name: "Activos y Suspendidos (1,4)",
  //     data: [34, 40, 28, 52, 42, 109, 100, 8, 12, 39, 11, 13],
  //   },
  //   {
  //     name: "Egresados",
  //     data: [32, 60, 34, 46, 34, 52, 41, 8, 12, 39, 11, 13],
  //   },
  // ]

  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          if (value >= 1000000) {
            return parseInt(value / 1000000) + "M" // Millones
          } else if (value >= 1000) {
            return parseInt(value / 1000) + "K" // Miles
          }
          return parseInt(value) // Menos de 1000, se muestra normal
        },
        style: {
          fontWeight: "bold", // Hace que el texto sea en negritas
          fontSize: "14px", // Ajusta el tamaño si lo necesitas
          colors: "#333", // Color del texto (puedes cambiarlo)
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },

    colors: spineareaChartColors,
    xaxis: {
      type: "date",
      categories: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  }

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="area"
      height="350"
    />
  )
}

export default Splinearea
